import { render, staticRenderFns } from "./ProductIndex.vue?vue&type=template&id=dcd67488&scoped=true&"
import script from "./ProductIndex.vue?vue&type=script&lang=js&"
export * from "./ProductIndex.vue?vue&type=script&lang=js&"
import style0 from "./ProductIndex.vue?vue&type=style&index=0&id=dcd67488&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcd67488",
  null
  
)

export default component.exports